export default {"src":"/_next/static/media/ico_heart-white.d880eab7.svg","height":20,"width":20};